import { Box, Typography } from '@mui/material';

import { CopyButton } from 'modules/common/components/CopyButton';
import { isMac } from 'modules/common/utils/isMac';
import { useIsSMDown } from 'uiKit/Theme/useTheme';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { getGRPCCodeExample } from './utils/getGRPCCodeExample';
import { grpcCodeExampleTranslation } from './translation';
import { useGRPCCodeExampleStyles } from './useGRPCCodeExampleStyles';

interface GRPCCodeExampleProps {
  url: string;
  xToken: string;
}

export const GRPCCodeExample = ({ url, xToken }: GRPCCodeExampleProps) => {
  const { classes, cx } = useGRPCCodeExampleStyles();

  const { keys, t } = useTranslation(grpcCodeExampleTranslation);

  const code = getGRPCCodeExample(xToken, url);

  const isMobile = useIsSMDown();

  const codeClassName = cx(classes.code, {
    [classes.codeScrollbar]: !isMac() && !isMobile,
  });

  return (
    <div className={classes.root}>
      <Typography color="textPrimary" variant="subtitle2">
        {t(keys.codeExample)}
      </Typography>
      <Box className={classes.box}>
        <pre className={codeClassName}>{code}</pre>
        <CopyButton
          classes={{ copyIcon: classes.copyIcon }}
          size="small"
          text={code}
        />
      </Box>
    </div>
  );
};
